const language = {
	spanish: {
		header_title: "Flota ",
		header_yellow_span: "Marina",
		flotas_red_title: "MANEJO DE FLOTAS MARÍTIMAS",
		flotas_bold_title:
			"El manejo de flotas comerciales suele ser un proceso complejo debido a la magnitud de los activos móviles y todos los factores que se deben controlar al mismo tiempo",
		flotas_bold_text:
			"Sin importar el tipo de embarcación, en Foresight GPS podemos instalar e integrar distintos tipos de sensores en estos vehículos para proteger la inversión y maximizar el rendimiento de estas.",
		flotas_text: [
			"Es difícil ubicar las embarcaciones sobre las superficies acuáticas. No hay una dirección clara cuando desea saber dónde está.",
			"Es por eso que el rastreo vía GPS es una solución efectiva y alcanzable para todos los usuarios de una flota personal o de un negocio de renta de embarcaciones.",
		],
		beneficios_list: [
			{
				text: "Conozca la ubicación de sus embarcaciones en tiempo real sobre mapas digitalizados desde cualquier dispositivo.",
				column: "1",
			},
			{ text: "Prevenga robos.", column: "1" },
			{
				text: "Controle uso de la embarcación para prevenir malos usos.",
				column: "1",
			},
			{
				text: "Reciba alertas de exceso de velocidad en embarcaciones.",
				column: "1",
			},
			{
				text: "Administre el uso de combustible remotamente.",
				column: "2",
			},
			{
				text: "Obtenga un inventario y ubicación de la flota en un instante.",
				column: "2",
			},
			{
				text: "Reciba alertas de seguridad por rebasar límites a través de geocercas digitales.",
				column: "2",
			},
			{
				text: "Rastrear el paradero de la embarcación en caso de roboSoporte 24/7.",
				column: "2",
			},
		],
		caracteristicas_red_text: "CARACTERÍSTICAS",
		caracteristicas_bold_text:
			"Nuestro software de gestión es fácil de usar y mejora el rendimiento de los equipos teniendo en cuenta su mantenimiento y uso.",
		caracteristicas_text: [
			"Estas funcionalidades ayudan tanto a fabricantes de equipos como a técnicos/operadores a optimizar los recursos de servicio en el campo y en la oficina. Contamos con la mejor innovación tecnológica para un rastreo óptimo de sus activos móviles:",
		],
		caracteristicas_list: [
			"Generación de variedad de alertas según la necesidad de la operación.",
			"Integración de gran catálogo de dispositivos GPS.",
			"Gestión de activos acuáticos desde aplicación web o móvil.",
			"Configuración de alertas de mantenimiento preventivo por distancia u horas de uso.",
			"Configuración de alertas de proximidad entre embarcaciones",
		],
		dashboard_red_title: "DASHBOARD CENTER",
		dashboard_bold_title:
			"Fue diseñado para visualizar los indicadores clave de rendimiento de forma rápida y eficiente, facilitando la toma de decisiones ante grandes volúmenes de datos.",
		dashboard_bold_text:
			"Con distintos conjuntos de tableros puedes ver la velocidad media, máxima y promedio de la flota, el kilometraje por unidad, el consumo de combustible promedio individual o por flota, las horas del motor encendido y el tiempo en los viajes, y más.",
		dashboard_text: [
			"Además se pueden incluir nuevos sets de datos y personalizar los Dashboard a las necesidad específicas de cada operación.",
		],
		dashboard_list: [
			"Procesamiento de data.",
			"Presentación gráfica de resultados.",
			"Comparativo de resultados entre diferentes vehículos.",
			"Identificador de variables fuera de rango.",
			"Interfaz gráfica amigable y fácil de leer.",
			"Control de múltiples variables de manera simultánea.",
			"Información discriminada en piloto/embarcación y flota.",
		],
	},
	english: {
		header_title: "Marine ",
		header_yellow_span: "Fleet",
		flotas_red_title: "MARITIME FLEET MANAGEMENT",
		flotas_bold_title:
			"Commercial fleet management is often a complex process due to the magnitude of the mobile assets and all the factors that must be controlled at the same time.",
		flotas_bold_text:
			"Regardless of the type of vessel, at Foresight GPS we can install and integrate different types of sensors in these vehicles to protect the investment and maximize the performance of these.",
		flotas_text: [
			"It is difficult to locate boats on water surfaces. There is no clear direction when you want to know where it is.",
			"That is why GPS tracking is an effective and affordable solution for all users of a personal fleet or boat rental business.",
		],
		beneficios_list: [
			{
				text: "Know the location of your boats in real time on a digital map from any device.",
				column: "1",
			},
			{ text: "Theft prevention.", column: "1" },
			{
				text: "Control boat use and prevent misuse.",
				column: "1",
			},
			{
				text: "Receive alerts on speeding boats.",
				column: "1",
			},
			{
				text: "Manage fuel usage remotely.",
				column: "2",
			},
			{
				text: "Get inventory and location of the fleet in an instant.",
				column: "2",
			},
			{
				text: "Receive safety alert for exiting digital geofences.",
				column: "2",
			},
			{
				text: "Track the whereabouts of the vessel in case of theftSupport 24/7.",
				column: "2",
			},
		],
		caracteristicas_red_text: "FEATURES",
		caracteristicas_bold_text:
			"Our management software is easy to use and improves equipment performance by taking into account maintenance and usage.",
		caracteristicas_text: [
			"These functionalities help both equipment manufacturers and technicians/operators to optimize service resources in the field and in the office. We have the best technological innovation for optimal tracking of your mobile assets:",
		],
		caracteristicas_list: [
			"Custom alerts according to the need of the operation.",
			"Integration of a large catalog of GPS devices.",
			"Management of aquatic assets on the mobile app or web.",
			"Configuration of preventive maintenance alerts by distance or hours of use.",
			"Configuration of proximity alerts between vessels.",
		],
		dashboard_red_title: "DASHBOARD CENTER",
		dashboard_bold_title:
			"Designed to display key performance indicators quickly and efficiently, facilitating decision making when faced with large volumes of data.",
		dashboard_bold_text:
			"With different sets of dashboards allow you to view fleet average, maximum and average speed, milage per unit, average of fuel consumption of the fleet or individual, engine running hours, and more.",
		dashboard_text: [
			"Also can be customized to the specific needs of operation, including new data sets.",
		],
		dashboard_list: [
			"Data processing.",
			"Graphic presentation of results.",
			"Comparison of results between different vehicles.",
			"Out of range variable identifier.",
			"Friendly and easy-to-read graphical interface.",
			"Simultaneous control of multiple variables.",
			"Information on pilot, boat or fleet.",
		],
	},
};

export default language;
